import { useState } from 'react';
import Modal from '../../components/common/Modal';

export default function HospitalForm({ hospital, onClose, onSalvar }) {
  const [nome, setNome] = useState(hospital?.nome || '');
  const [cnpj, setCnpj] = useState(hospital?.cnpj || '');
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setEnviando(true);
    try {
      await onSalvar({ nome, cnpj: cnpj || null });
      onClose();
    } catch {
      setErro('Não foi possível salvar. Tente novamente.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <Modal titulo={hospital ? 'Editar hospital' : 'Novo hospital'} onClose={onClose}>
      <form className="am-form" onSubmit={handleSubmit}>
        <label className="am-field">
          <div className="am-field__label-row">
            <span className="am-field__label">Nome do hospital</span>
          </div>
          <input value={nome} onChange={(e) => setNome(e.target.value)} placeholder="Hospital Santa Clara" required />
        </label>

        <label className="am-field">
          <div className="am-field__label-row">
            <span className="am-field__label">CNPJ (opcional)</span>
          </div>
          <input value={cnpj} onChange={(e) => setCnpj(e.target.value)} placeholder="00.000.000/0000-00" />
        </label>

        {erro && <div className="am-field__error">{erro}</div>}

        <div className="am-form__actions">
          <button type="button" className="am-btn am-btn-outline" onClick={onClose}>
            Cancelar
          </button>
          <button type="submit" className="am-btn am-btn-dark" disabled={enviando}>
            {enviando ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
